import type { RouteObject } from "react-router-dom";
import { PagesNrtProviderConfigToolUiDisplay } from "./Display";

export const PagesNrtProviderConfigToolUiRoutes: RouteObject[] = [
  {
    path: "nrtProviderConfigTool",
    element: <PagesNrtProviderConfigToolUiDisplay />
  }
];
